import { formNow, pathIn, type FormNow } from '../engine/formNow';
import { fieldTypeOf } from '../field-types';
import { fieldsOf, holdsFields } from '../format/elements';
import type { FieldElement, FormDefinition } from '../format/form-definition';
import { placesOf, type Places } from '../format/references';
import { FillValues, newRowValues, startValues } from '../rendering/values';
import { FillBounds } from '../field-types/fillInput';
import { todayIsoDate } from 'framework/utils/hooks/useDateService';

interface FieldPreview {
  required: boolean;
  bounds: FillBounds;
  value: unknown;
}

export const fieldPreview = (form: FormDefinition, field: FieldElement): FieldPreview => {
  const { now, places } = previewOf(form);
  const group = places.get(field.id)?.group;
  const at = now.fields.get(group ? pathIn(`${group.id}.0`, field.id) : field.id);
  return {
    required: at?.required ?? false,
    bounds: at?.range ?? {},
    value: field.defaultValue ?? fieldTypeOf(field).emptyValue,
  };
};

const previews = new WeakMap<FormDefinition, { now: FormNow; places: Places }>();

const previewOf = (form: FormDefinition) => {
  let preview = previews.get(form);
  if (!preview) {
    const today = todayIsoDate();
    const values: FillValues = startValues(form, today);
    for (const group of fieldsOf(form.elements).filter(holdsFields)) {
      const rows: unknown = values[group.id];
      if (!Array.isArray(rows) || rows.length === 0) values[group.id] = [newRowValues(group)];
    }
    preview = { now: formNow(form, values, today), places: placesOf(form) };
    previews.set(form, preview);
  }
  return preview;
};
